import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';

import { OutlineLabel } from '../../../../../../../atoms/OutlineLabel';
import CheckInput, { InputType } from '../../../../../../../atoms/CheckInput';
import BooksTimeItem from '../../texts/BooksTimeItem';

import css from './BooksSelectTimeInstructor.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  startTime: string;
  endTime: string;
  instructors?: string[];
  vacancy: number;
  showVacancy: boolean;
  value: number;
  checked: boolean;
  onChange?: (e: React.ChangeEvent) => void;
}

const BooksSelectTimeInstructor = ({
  startTime,
  endTime,
  instructors,
  vacancy,
  showVacancy,
  value,
  checked,
  onChange,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(css.BooksSelectTimeInstructor);
  const labelClasses = classNames(css.BooksSelectTimeInstructor__Label, {
    [css.isSoldOut]: !vacancy,
  });

  return (
    <div className={classes}>
      <CheckInput
        type={InputType.Checkbox}
        name="select-time"
        checked={checked}
        onChange={onChange}
        disabled={vacancy < 1}
        labelPosition="SpaceBetween"
        value={value}
      >
        <BooksTimeItem
          startTime={startTime}
          endTime={endTime}
          instructors={instructors}
          className={vacancy < 1 ? css.isDisabled : ''}
        />
        {vacancy > 0 ? (
          showVacancy && (
            <OutlineLabel
              label={`${intl.formatMessage({
                id: 'merchants.services.status.vacancy',
              })} ${vacancy}`}
              className={labelClasses}
            />
          )
        ) : (
          <OutlineLabel
            label={intl.formatMessage({
              id: 'merchants.services.status.soldOut',
            })}
            className={labelClasses}
          />
        )}
      </CheckInput>
    </div>
  );
};

export default BooksSelectTimeInstructor;
